<template>
  <div class="wxpay-wrap">
      <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :show-close="false"
        width="370px"
        @close="handleClose">
            <div class="m-dialog_header u-flex u-row-between">
                <span>微信支付</span>
                <div class="m-dialog_close" @click="cancalFun">
                    <i class="el-icon-close"></i>
                </div>
            </div>
          <div class="m-qcode">
              <img :src="qrcode" alt="">
          </div>
      </el-dialog>
  </div>
</template>

<script>
var _timeFun = null
export default {
    data(){
        return {
            dialogVisible:false,
            orderId:'',
            qrcode:''
        }
    },
    methods:{
        init(id){
            console.log(id);
            this.orderId = id
            this.$http.get('orders_wxNativePay',{order_id:id}).then(res=>{
                if(res.code == 1){
                    this.dialogVisible = true
                    this.qrcode = res.data.qrcode
                    this.checkResultFun()
                }else{
                    this.$message.error(res.message)
                }
            })
            
        },
        checkResultFun(){
            _timeFun = setInterval(()=>{
                this.$http.get('orders_detail',{id:this.orderId}).then(res=>{
                    if(res.code == 1){
                        if(res.data.status == 2){
                            this.success()
                        }
                    }
                })
            },3000)
        },
        handleClose(){
            this.dialogVisible = false
            
        },
        cancalFun(){
            this.$message.error('支付取消')
            this.dialogVisible = false
            clearInterval(_timeFun)
            this.$emit('cancel',{id:this.orderId})
        },
        success(){
            this.$message.success('支付成功')
            this.dialogVisible = false
            clearInterval(_timeFun)
            this.$emit('success',{id:this.orderId})
        }
    }
}
</script>
<style lang="scss">
.wxpay-wrap{
    .el-dialog__header{
        padding: 0;
    }
    .el-dialog__body{
        padding: 0 0 20px 0;
    }
    .m-dialog_header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        height: 60px;
        background: #F5F5F5;
        line-height: 60px;
        .m-dialog_close{
            text-align: center;
            line-height: 30px;
            width: 30px;
            height: 30px;
            cursor: pointer;
            font-size: 20px;
            color: #666;
        }
    }
    .m-qcode{
        display: flex;
        justify-content: center;
        margin: 20px auto;
        img{
            width: 234px;
            height: 234px;
        }
    }
}
</style>
